const C = require("../constants");

const selectIngredient = (data) => {
    return {
        type: C.INGREDIENT_SELECT,
        data
    }
};

export {selectIngredient};


// WEBPACK FOOTER //
// ./src/actions/IngredientSelectAction.js